<div class="phone-modal-overlay" (click)="close()">
  <div class="phone-modal-card" (click)="$event.stopPropagation()">
    <button type="button" class="phone-modal-close" (click)="close()" aria-label="Fechar">
      <ion-icon name="close"></ion-icon>
    </button>
    <div class="phone-modal-header">
      <ion-icon name="call-outline" class="phone-modal-icon"></ion-icon>
      <h2 class="phone-modal-title">Seu telefone</h2>
      <p class="phone-modal-subtitle">
        Para que o vendedor possa entrar em contato com você em caso de dúvidas ou sobre sua compra, informe seu número de telefone.
      </p>
    </div>

    <form [formGroup]="form" class="phone-modal-form">
      <ion-item class="phone-modal-input" lines="none">
        <ion-icon name="call-outline" slot="start"></ion-icon>
        <input
          class="phone-modal-input-native"
          formControlName="phone"
          type="tel"
          placeholder="(00) 00000-0000"
          mask="(00) 00000-0000"
          inputmode="numeric"
          (input)="errorMessage = ''"
        />
      </ion-item>
    </form>

    <p class="phone-modal-error" *ngIf="errorMessage">{{ errorMessage }}</p>
    <div class="phone-modal-loading" *ngIf="loading">
      <ion-spinner name="crescent"></ion-spinner>
      <span>Salvando...</span>
    </div>

    <div class="phone-modal-actions">
      <ion-button
        expand="block"
        class="phone-modal-btn-submit"
        (click)="submit()"
        [disabled]="form.invalid || loading">
        <ion-icon name="checkmark-circle-outline" slot="start"></ion-icon>
        Salvar e continuar
      </ion-button>
    </div>
  </div>
</div>
